import React, { useEffect, useRef, useState } from 'react';
import { CheckCircle2, PenLine } from 'lucide-react';
import { useT } from '../../salesI18n';
import { useSalesAuth } from '../../SalesAuthContext';
import { salesApi } from '../../salesApi';
import { SignaturePad, padPng } from './SignaturePad';

// Assinatura do vendedor no fechamento: usa a salva no perfil (prévia) ou desenha na hora.
export const RepSignatureField = ({ onChange }) => {
  const { t } = useT();
  const { user } = useSalesAuth();
  const padRef = useRef(null);
  const [mode, setMode] = useState(user?.has_signature ? 'saved' : 'draw');
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!user?.has_signature) return undefined;
    let url;
    salesApi.get('/auth/signature', { responseType: 'blob' }).then((r) => { url = URL.createObjectURL(r.data); setPreview(url); }).catch(() => setMode('draw'));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [user?.has_signature]);

  useEffect(() => { onChange?.(mode === 'saved' ? { saved: true } : { pad: padRef }); }, [mode, onChange]);

  return (
    <div className="rounded-2xl border border-slate-200/70 bg-slate-50/60 p-3 space-y-2" data-testid="rep-signature-field">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-xs font-semibold text-slate-700">{t.repSignature} · {user?.full_name}</p>
          <p className="text-[11px] text-slate-500">{t.repSignatureHint}</p>
        </div>
        {user?.has_signature && (
          <div className="inline-flex rounded-full border border-teal-200 bg-white overflow-hidden text-[11px] font-semibold">
            <button type="button" onClick={() => setMode('saved')} className={`px-3 h-8 ${mode === 'saved' ? 'bg-teal-600 text-white' : 'text-teal-800'}`} data-testid="rep-sig-mode-saved">{t.useSavedSignature}</button>
            <button type="button" onClick={() => setMode('draw')} className={`px-3 h-8 border-l border-teal-200 ${mode === 'draw' ? 'bg-teal-600 text-white' : 'text-teal-800'}`} data-testid="rep-sig-mode-draw">{t.drawNow}</button>
          </div>
        )}
      </div>
      {mode === 'saved' ? (
        <div className="flex items-center gap-3 rounded-xl bg-white border border-slate-200 p-2" data-testid="rep-sig-saved-preview">
          {preview ? <img src={preview} alt="" className="h-14 object-contain" /> : <span className="h-14 w-32 rounded bg-slate-100 animate-pulse" />}
          <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-700"><CheckCircle2 className="h-4 w-4" /> {t.savedSignature}</span>
        </div>
      ) : (
        <SignaturePad ref={padRef} label={<span className="inline-flex items-center gap-1"><PenLine className="h-3 w-3" /> {t.signHere.replace(/ \(.*\)$/, '')}</span>} clearLabel={t.clearSignature} testId="rep-signature-pad" height={140} />
      )}
    </div>
  );
};

export const repSignaturePng = (state) => (state?.saved ? undefined : padPng(state?.pad));
